export function isStringIncludes(origin: string, query: string): boolean {
    return origin.toLowerCase().includes(query.toLowerCase());
}
